// extracted by mini-css-extract-plugin
export default {"walletIdWrapper":"WalletId_walletIdWrapper__-aIfM","walletIdIcon":"WalletId_walletIdIcon__TAwM7","walletId":"WalletId_walletId__5smTU"};